import React from 'react';
import { ControlProps, GroupBase, StylesConfig } from 'react-select';

const useReactSelect = (isInvalid: boolean) => {
  const customStyle: StylesConfig<{ value: any; label: string; }, false, GroupBase<{ value: string; label: string; }>> = React.useMemo(() => {
    const renderBorderColor = (state: ControlProps<{value: any, label: string}, false, GroupBase<{value: string, label: string}>>) => {
      if (state.isDisabled) return '#E6E6E6';
      if (isInvalid) return 'red';
      if (state.isFocused) return '#86b7fe';
      return '#E6E6E6';
    };
    return {
      control: (provided, state) => ({
        ...provided,
        borderRadius: '20px',
        height: '42px',
        paddingLeft: '10px',
        paddingRight: '10px',
        fontSize: '14px',
        borderColor: renderBorderColor(state),
        outline: 0,
        color: '#212529',
        boxShadow: state.isFocused ? '0 0 0 .25rem rgba(13,110,253,.25)' : '',
        '&:hover': {
          borderColor: renderBorderColor(state),
        },
        backgroundColor: state.isDisabled ? '#e9ecef' : 'transparent',
      }),
      placeholder: (defaultStyles) => ({
        ...defaultStyles,
        color: '#AEAEAE',
        marginTop: '1px',
        fontSize: '14px',
      }),
      singleValue: (defaultStyles) => ({
        ...defaultStyles,
        marginTop: '1px',
      }),
    };
  }, [isInvalid]);

  return {
    customStyle,
  };
};

export default useReactSelect;
